import {forwardRef, useImperativeHandle, useState} from "react";
import {Modal} from "antd";
import {useTranslation} from "react-i18next";
import "./DialogWordCount.css"
import {IconClose} from "@/Icon";
import {countWords, removeHtmlTags} from "@/utils";

const DialogWordCount = forwardRef((props,refs)=>{
    useImperativeHandle(refs,()=>({
        onShowDialog:onShowDialog
    }))
    const {t} = useTranslation();
    const [isShowDialog,setIsShowDialog] = useState(false);
    const [characterCount,setCharacterCount]=useState(0);
    const [wordCount,setWordCount] = useState(0);

    const onShowDialog = (szStr)=>{
        setIsShowDialog(true);
        szStr = removeHtmlTags(szStr);
        setWordCount(countWords(szStr));
        setCharacterCount(szStr.length);
    }

    // function countWords(str) {
    //     // 去除多余空格并将字符串转换为小写
    //     str = str.replace(/^\s+|\s+$/g, '').toLowerCase();
    //     // 定义匹配单词的正则表达式
    //     var regex = /\w+/g;
    //     // 利用 match() 函数获取所有匹配到的单词
    //     var words = str.match(regex);
    //
    //     return (words || []).length;
    // }

    return(
        <Modal visible={isShowDialog} width='230px' closable={true} closeIcon={<IconClose/>} onCancel={()=>setIsShowDialog(false)} footer={''} centered={true}>
            <span className='dialog-title' style={{display:'flex',alignItems:'center'}}>{t("Word static")}</span>
            <table className='table' border='0' style={{marginTop:'12px',width:'100%',marginBottom:'-26px'}}>
                <tr style={{width:'100%',display:'flex'}}>
                    <td style={{flexGrow:'1'}}>{t("Number of character")}</td>
                    <td>{characterCount}</td>
                </tr>
                <tr style={{width:'100%',display:'flex',marginTop:'-2px'}}>
                    <td style={{flexGrow:'1'}}>{t("Word count")}</td>
                    <td>{wordCount}</td>
                </tr>
            </table>
        </Modal>
    )
})

export default DialogWordCount;